import { userConstants } from './../constants/user.constants';

const initialState = {};

export function Products(state = initialState, action) {
  switch (action.type) {
    case userConstants.PRODUCTS_REQUEST:
      return {
        user: action.user,
        isLoading : true

      };
    case userConstants.PRODUCTS_SUCCESS:
      const {res} = action
        
      return {
        res,
        isLoading : false
      };
    case userConstants.PRODUCTS_FAILURE:
      return {
        isLoading : false
      };
    default:
      return state
  }
}